import React from "react";
import { Link} from "react-router-dom";
import siteLogo from "../../../assets/images/logo_new.png"

const ResetPassword = () => {
    return (
        <div className="signup-wrapper-area payment-wrapper">
            <div className="quick-start-section">
                    <div className="logo-center">
                        <Link to="https://cardiast.com" target="_blank"><img src={siteLogo} alt="Cardiast Logo" /></Link>
                    </div>
                    <div className="signIn-wrapper">
                        <h2 className="form-title">Reset Password</h2>
                        <p>Enter your new password.</p>
                        <form 
                            action="#" 
                            className="action-form signIn-form" 
                            method="POST"
                        >
                            <div className="form-wrapper">
                                <div className="form-group">
                                    <input type="password" className="form-control" name="password" placeholder="Password" required />
                                </div>
                                <div className="form-group">
                                    <input type="password" className="form-control" name="conformPassword" placeholder="Conform Password" required />
                                </div>
                                <div className="form-group">      
                                    <button 
                                        type="submit" 
                                        className="btn continue_button submit_button btn-primary btn-block mt-4"
                                    >
                                        Submit
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path>
                                        </svg>
                                    </button>  
                                </div>                 
                            </div>                    
                        </form>      
                    </div>
                    <div className="signup-footer d-flex">
                        <Link className="back_home_btn btn btn-block" to="/login">
                                    <i className="ri-arrow-left-line"></i> 
                                    Back to login
                        </Link>
                    </div>
                </div>
        </div>
    );
}

export default ResetPassword;
